import * as React from 'react';
import { SVGProps } from 'react';

const IconFileMailSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5h20v14H2V5Zm1.94 1L12 12.363 20.06 6H3.94ZM21 6.532l-6.014 4.747L21 17.293V6.532ZM20.293 18l-6.097-6.097L12 13.637l-2.196-1.734L3.707 18h16.586ZM3 17.293V6.532l6.014 4.747L3 17.293Z"
    />
  </svg>
);
export default IconFileMailSizeM;
